import { useState, useRef } from 'react';

/**
 * Hook to enable mouse-drag scrolling on a container.
 */
export const useDraggableScroll = () => {
    const scrollerRef = useRef<HTMLDivElement>(null);
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [startX, setStartX] = useState<number>(0);
    const [scrollLeftState, setScrollLeftState] = useState<number>(0);
    const [dragMoved, setDragMoved] = useState<boolean>(false);

    const onMouseDown = (e: React.MouseEvent) => {
        if (!scrollerRef.current) return;
        setIsDragging(true);
        setDragMoved(false);
        setStartX(e.pageX - scrollerRef.current.offsetLeft);
        setScrollLeftState(scrollerRef.current.scrollLeft);
    };

    const onMouseLeave = () => setIsDragging(false);
    const onMouseUp = () => setIsDragging(false);

    const onMouseMove = (e: React.MouseEvent) => {
        if (!isDragging || !scrollerRef.current) return;
        e.preventDefault();
        const x = e.pageX - scrollerRef.current.offsetLeft;
        const walk = (x - startX) * 2; 
        if (Math.abs(walk) > 5) setDragMoved(true);
        
        // Decouple from event thread to resolve scroll-linked warning
        const targetScrollLeft = scrollLeftState - walk;
        requestAnimationFrame(() => {
            if (scrollerRef.current) {
                scrollerRef.current.scrollLeft = targetScrollLeft;
            }
        });
    };

    return {
        scrollerRef,
        isDragging,
        dragMoved,
        scrollHandlers: {
            onMouseDown,
            onMouseLeave,
            onMouseUp,
            onMouseMove
        }
    };
};
